import React, { useState, useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import FileCard from "./filecard.js";
import FileRow from "./filerow.js";
import { useTranslation } from "react-i18next";
import FilesSearch from './files-search';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Card,
} from '@mui/material';

export default function DataList({ data, reloadProjects, processings }) {
  const { t } = useTranslation();

  const [view, setView] = useState("grid");
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("new");

  const displayedData = useMemo(() => {
    // Filter the data based on the search filter
    const filtered = data.filter(item => 
      item.attributes.filename.includes(filter) ||
      item.attributes.description.includes(filter)
    );

    // Create a copy to avoid mutating the original array and sort it
    const sorted = [...filtered];
    if (sort === "old") {
      sorted.sort((a, b) => new Date(a.attributes.createdAt) - new Date(b.attributes.createdAt));
    } else if (sort === "new") {
      sorted.sort((a, b) => new Date(b.attributes.createdAt) - new Date(a.attributes.createdAt));
    } else if (sort === "big") {
      sorted.sort((a, b) => b.attributes.size - a.attributes.size);
    } else if (sort === "small") {
      sorted.sort((a, b) => a.attributes.size - b.attributes.size);
    }
    return sorted;
  }, [data, filter, sort]);

  if (data.length === 0) {
    return (
      <Typography color="text.secondary" variant="body1" sx={{ p: 3 }}>
        {t("ProjectEmpty")}
      </Typography>
    );
  }

  return (
    <>
      <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
        <FilesSearch 
          view={view} 
          setView={setView} 
          filter={filter} 
          setFilter={setFilter} 
          sort={sort} 
          setSort={setSort} 
        />
      </Box>
      {view === "grid" && (
        <Grid container spacing={3} sx={{ paddingLeft: 2, paddingRight: 2 }} columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 6 }}>
          {displayedData.map((file, index) => (
            <Grid key={index} size={1}>
              <FileCard data={file} reloadProjects={reloadProjects} processings={processings}/>
            </Grid>
          ))}
        </Grid>
      )}
      {view === "list" && (
        <Box sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Card
            sx={{ 
              p: 0,
              '&:hover': {
                boxShadow: '0px 5px 22px rgba(0, 0, 0, 0.06), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.04)',
                transform: 'none',
              }
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 150 }}>{t("File")}</TableCell>
                  <TableCell>{t("Description")}</TableCell>
                  <TableCell sx={{ width: 100 }}>{t("Date")}</TableCell>
                  <TableCell align="right" sx={{ width: 100 }}>{t("Size")}</TableCell>
                  <TableCell align="right" sx={{ width: 40 }} />
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedData.map((file, index) => (
                  <FileRow key={index} data={file} id={index} reloadProjects={reloadProjects} processings={processings}/>              
                ))}
              </TableBody>
            </Table>
          </Card>
        </Box>
      )}
    </>
  );
}
